import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';

const TvTableSizeToggle = ({label, tableViewKey, currentSize, minMax=[-99, 99], handlePvOptionChange}) => {
    return (
        <>
            <span>{label}</span>
            <OptionButton imgClassName={`magOptionsSmall ${minMax[0] === currentSize ? 'disableImg' : ''}`} src={magMinus} message={`Shrink ${label}`} onClickFunction={()=> handlePvOptionChange('tableView', tableViewKey, -1)}/>
            <OptionButton imgClassName={`magOptionsSmall ${minMax[1] === currentSize ? 'disableImg' : ''}`} src={magPlus} message={`Grow ${label}`} onClickFunction={()=> handlePvOptionChange('tableView', tableViewKey, 1)}/>
            <div>
                &nbsp;({currentSize}<span style={{fontSize: '8px'}}>x</span>) 
            </div>
        </>
    );
}

export default TvTableSizeToggle;